<template>
  <div
    :style="styleObject"
    class="strip-bar"
  />
</template>

<script>
export default {
  name: 'StripBar',
  props: {
    level: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    styleObject() {
      return {
        width: `${this.width}px`,
        left: `${this.level * this.width}px`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.strip-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: $color-default;
}
</style>

